import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import Cfa2SubscriptionCheck from '../../RestAPI/Cfa2Subscription';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa2SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa2Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import AlertMessage from '../../config/alertMessage';
import Loader from '../../../common/loader';
import CBTMockExamsInsructions from '../../Common/CBTInstructions';
import moment from 'moment';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { SecondsToHHMMSS } from '../../../common/constant';
import AppRoutes from '../../config/AppRoutes';
import { hasMockAccessFromBackend } from '../../../utils/CommonUtils';
/* eslint-disable */

class AttemptedTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      mockList: [],
      token: '',
      idname: '',
      ValidToken: false,
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'cfa_2',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      isLoading: true,
      mockData: '',
      userStatsData: '',
      mockName: '',
      deletepopup: false,
      deleteId: '',
      totalQuestionsCount: 1,
      timer: this.props.params.timer,
    };

    this.filePath = this.props.location.pathname.includes('/cfa3/')
      ? 'cfa3CBTMockExams'
      : 'cfa2CBTMockExams';
    this.questionRoute = this.props.location.pathname.includes('/cfa3/')
      ? AppRoutes.CFA3_CBT_QUESTIONS
      : AppRoutes.CFA2_CBT_QUESTIONS;
    this.finishRoute = this.props.location.pathname.includes('/cfa3/')
      ? AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS
      : AppRoutes.CFA2_CBT_QUESTIONS_FINISH;
  }

  toggleAlert = () => {
    this.setState({
      isLoading: false,
      alert_status: !this.state.alert_status,
    });
  };

  //it is use to redirect page
  static contextTypes = { router: React.PropTypes.object };

  //Function to redirect page to viewquestions page
  //check CFA2 subscription
  getQuestions = () => {
    this.setState({
      showInstructionModal: false,
      isLoading: true,
    });
    const user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, user_data).then((resp) => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            async (resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                let selectedmen = this.state.selectedmenu;
                let isInArray_var = false;
                let partnerSubscriptionCheck = PartnerCfa2SubscriptionCheck.checkCfa2Subscription;
                if (this.props.location.pathname.includes('/cfa3/')) {
                  partnerSubscriptionCheck = PartnerCfa3SubscriptionCheck.checkCfa3Subscription;
                  selectedmen = 'cfa_3';
                }
                isInArray_var = await partnerSubscriptionCheck(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                if (isInArray_var || hasMockAccess) {
                  this._runCode('paid');
                } else {
                  this.toggleAlert();
                }
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
          this.setState({ subscriptionstatus: 'free' });
          this._runCode('free');
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            (resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                let selectedmen = this.state.selectedmenu;
                let isInArray_var = false;
                let subscriptionCheck = Cfa2SubscriptionCheck.checkCfa2Subscription;
                if (this.props.location.pathname.includes('/cfa3/')) {
                  subscriptionCheck = Cfa3SubscriptionCheck.checkCfa3Subscription;
                  selectedmen = 'cfa_3';
                }
                isInArray_var = subscriptionCheck(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                if (isInArray_var || hasMockAccess) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.toggleAlert();
                }
              } else {
              }
            },
          );
        }
      }
    });
  };

  _runCode = (subscriptionstatus) => {
    const {
      state: { timer },
      props: {
        params: { id },
      },
    } = this;
    if (subscriptionstatus === 'paid') {
      const { session, pathway } = this.props.params;
      const path = AppRoutes.CFA3_PATHWAY_CBT_INTRODUCTION.replace(':pathway', pathway)
        .replace(':session', session)
        .replace(':questiono', 1)
        .replace(':timer', timer);
      this.context.router.push({ pathname: path });
    }
  };

  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : '',
      pathwayId: this.props.params.pathway,
      sessionId: this.props.params.session,
    };
    FD.callAPI(`${App_data.backend_api}/cfa3PathwayExams/getAllAttemptedTest`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            mockList: resp.data,
            isLoading: false,
          });
        } else {
          this.setState({
            ValidToken: false,
            isLoading: false,
          });
        }
        return resp;
      },
    );

    FD.callAPI(`${App_data.backend_api}/cfa3PathwayExams/getTotalQuestionsCount`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ totalQuestionsCount: resp.question });
        } else {
        }
      },
    );
    FD.callAPI(`${App_data.backend_api}/cfa3PathwayExams/getMockNameById`, data).then(
      async (res) => {
        this.setState({
          mockName: res.data && res.data.session_name ? res.data.session_name : '',
          pathwayDetails: (res.pathwayDetails && res.pathwayDetails.pathway_name) || '',
        });
      },
    );
  }

  goPremium = () => {
    this.context.router.push({
      pathname: AppRoutes.SUBSCRIBE,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  startExam = () => {
    this.setState({
      showInstructionModal: true,
      // mockData: mock,
    });
  };
  backToMock = () => {
    const { pathway } = this.props.params;
    this.context.router.push({
      pathname: AppRoutes.CFA3_PATHWAY_SESSION.replace(':pathway', pathway),
    });
  };
  deleteTest = (id) => {
    const { deletepopup } = this.state;
    if (!deletepopup) {
      this.setState({
        deleteId: id,
        deletepopup: true,
      });
    } else {
      this.setState({
        deleteId: '',
        deletepopup: false,
      });
    }
  };
  view = (item) => {
    let viewRoute = AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS_FINISH;
    if (item.status === 'non-graded') viewRoute = AppRoutes.CFA3_PATHWAY_CBT_GRADE_QUESTIONS;
    const {
      state: { timer },
      props: {
        params: { id },
      },
    } = this;
    const path = viewRoute
      .replace(':id', id)
      .replace(':caseno', 1)
      .replace(':questiono', 1)
      .replace(':testid', item.id)
      .replace(':caseOffset', 0)
      .replace(':quesOffset', 0)
      .replace(':timer', timer);

    this.context.router.push({ pathname: path });
  };
  deleteToggleDone = () => {
    const { deleteId } = this.state;
    const deleteData = {
      token: this.state.token,
      idname: this.state.idname,
      id: deleteId,
    };
    FD.callAPI(`${App_data.backend_api}/${this.filePath}/deleteMock`, deleteData).then(
      async (res) => {
        this.setState({
          deleteId: '',
          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
          deletepopup: false,
        });

        const data = {
          token: this.state.token,
          idname: this.state.idname,
          mock_id: this.props.params.id ? parseInt(this.props.params.id) : '',
          pathwayId: this.props.params.pathway,
          sessionId: this.props.params.session,
        };
        FD.callAPI(`${App_data.backend_api}/cfa3PathwayExams/getAllAttemptedTest`, data).then(
          (resp) => {
            if (resp.success) {
              this.setState({
                ValidToken: true,
                mockList: resp.data,
                isLoading: false,
                // userStatsData: resp.data,
              });
            } else {
              this.setState({ ValidToken: false, isLoading: false });
            }
            return resp;
          },
        );
        FD.callAPI(`${App_data.backend_api}/cfa3PathwayExams/getMockNameById`, data).then(
          async (res) => {
            this.setState({
              mockName: res.data && res.data.session_name ? res.data.session_name : '',
              pathwayDetails: (res.pathwayDetails && res.pathwayDetails.pathway_name) || '',
            });
          },
        );
      },
    );
  };

  resumeTest = (item) => {
    if (item.questions) {
      const questionsData = JSON.parse(item.lastAnswered);
      if (questionsData) {
        const {
          state: { timer },
        } = this;
        const path = AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS.replace(':id', item.mock_id)
          .replace(':session', this.props.params.session)
          .replace(':pathway', this.props.params.pathway)
          .replace(':caseno', questionsData.caseno)
          .replace(':questiono', questionsData.questionId)
          .replace(':timer', timer)
          .replace(':testid', item.id)
          .replace(':caseOffset', questionsData.caseOffset)
          .replace(':quesOffset', questionsData.offset)
          .replace(':isNegative', item.isNegative)
          .replace(':timerStart', true);
        this.context.router.push({ pathname: path });
      }
    } else {
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        sessionId: this.props.params.session,
        pathwayId: this.props.params.pathway,
      };

      FD.callAPI(`${App_data.backend_api}/cfa3CBTMockExams/getCFAMockCases`, data).then((resp) => {
        if (resp.success) {
          const {
            state: { timer },
          } = this;
          const path = AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS.replace(':id', item.mock_id)
            .replace(':session', this.props.params.session)
            .replace(':pathway', this.props.params.pathway)
            .replace(':caseno', 1)
            .replace(':questiono', 1)
            .replace(':timer', timer)
            .replace(':testid', item.id)
            .replace(':caseOffset', 0)
            .replace(':quesOffset', 0)
            .replace(':isNegative', true)
            .replace(':timerStart', true);
          this.context.router.push({ pathname: path });
        }
      });
    }
  };
  render() {
    const {
      mockList,
      isLoading,
      showInstructionModal,
      mockName,
      deletepopup,
      totalQuestionsCount,
      timer,
      pathwayDetails,
    } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper rem-left-pad'>
            <h1 className='section_head'>{`${pathwayDetails ? `${pathwayDetails} -` : ''} ${mockName}`}</h1>
            <div className='two-btn-wrapper'>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.startExam()}
              >
                {language.LC().START}
              </button>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.backToMock()}
              >
                Change Session
              </button>
            </div>
          </div>
          <Modal isOpen={deletepopup} toggle={this.deleteTest} className={'modal-primary'}>
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteTest}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{language.LC().ARE_YOU_SURE_TO_DELETE_THIS}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <div className='row' />
          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table table-remove-space'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='9%'>#</th>
                          <th>{language.LC().TOTAL_SCORE}</th>
                          <th>{language.LC().DATE}</th>
                          <th>{language.LC().TEST_COMPLETED_IN}</th>
                          <th>{language.LC().STATUS}</th>
                          <th className='text-center'>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <Loader />
                          </tr>
                        ) : mockList.length ? (
                          mockList.map((item, index) => {
                            let time = 0;
                            if (item.isNegative === 'true') {
                              time = SecondsToHHMMSS(parseInt(timer) - item.user_time_value);
                            } else {
                              time = SecondsToHHMMSS(parseInt(timer) + item.user_time_value);
                            }
                            return (
                              <tr key={index}>
                                <td>{item.id}</td>
                                <td className='score-qnt'>
                                  {item.score && totalQuestionsCount
                                    ? `${
                                        Math.ceil((item.score / totalQuestionsCount) * 100) > 100
                                          ? '0'
                                          : Math.ceil((item.score / totalQuestionsCount) * 100)
                                      }%`
                                    : '0%'}
                                </td>
                                <td>{item.createdAt ? moment(item.createdAt).format('ll') : ''}</td>
                                <td className='clr-green'>{time}</td>
                                <td className='text-capitalize mock-status'>
                                  {item.status === 'pending' ? (
                                    <div className='mock-status not-attempted'>
                                      {language.LC().Incomplete}
                                    </div>
                                  ) : item.status === 'non-graded' ? (
                                    <div className='mock-status not-attempted'>Non Graded</div>
                                  ) : (
                                    <div className='mock-status'>{item.status}</div>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {item.status === 'completed' || item.status === 'non-graded' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px 4px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().VIEW} </div>
                                      <i
                                        onClick={() => this.view(item)}
                                        className='fa fa-eye mark-action-btn-dashboard'
                                        style={{ color: '#1f8ceb' }}
                                      >
                                        {' '}
                                      </i>
                                    </span>
                                  ) : null}
                                  {item.status === 'pending' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px 4px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().RESUME}</div>
                                      <i
                                        className='fa fa-play-circle-o mark-action-btn-dashboard'
                                        aria-hidden='true'
                                        style={{ color: '#000' }}
                                        onClick={() => {
                                          this.resumeTest(item);
                                        }}
                                      />
                                    </span>
                                  ) : null}
                                  <span
                                    className='up tooltip-hover-questions'
                                    style={{ padding: '0 6px 4px' }}
                                  >
                                    <div className='tootip_box'> {language.LC().DELETE} </div>
                                    <i
                                      onClick={() => {
                                        this.deleteTest(item.id);
                                      }}
                                      className='fa fa-trash mark-action-btn-dashboard'
                                      style={{ color: '#f51a00' }}
                                    >
                                      {' '}
                                    </i>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan='6' className='no-mocks'>
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='82px'
                                  src={`${App_data.frontend_url}/img/questions/icon_nomock.png`}
                                />
                                <h3 className='mt-1'>{language.LC().NO_MOCK_EXAM_FOUND}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <CBTMockExamsInsructions
          showInstructionModal={showInstructionModal}
          getQuestions={() => this.getQuestions()}
          handleClose={() => this.setState({ showInstructionModal: false })}
        />
      </div>
    );
  }
}

export default AttemptedTest;



// WEBPACK FOOTER //
// ./src/views/CBT/pathway/AttemptedTest.js